import { render, staticRenderFns } from "./InformeCardLoader.vue?vue&type=template&id=523910c0&"
import script from "./InformeCardLoader.vue?vue&type=script&lang=js&"
export * from "./InformeCardLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports